<template>
  <div>
    <v-avatar tile size="90" :color="data.meetingType.color">
      <v-icon size="65" :dark="isDarkTheme">mdi-calendar</v-icon>
    </v-avatar>
  </div>
</template>

<script>
import customFunctions from "@/codeFiles/taskHelper.js";
export default {
  name: "AgendaViewMeetingTypeColumn",
  data() {
    return {
      data: {},
    };
  },
  computed: {
    isDarkTheme() {
      return customFunctions.getContrast(this.data.meetingType.color);
    },
  },
};
</script>

<style>
</style>